export const blockIconsHardwarePointOfSaleNew = (
	<span className='material-symbols-outlined'>point_of_sale</span>
);
